import React, { useState, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import ReactDOM from "react-dom";
import { Button, Input, Textarea } from "expano-components";
import { createUserAdjustment } from "actions/packer_dashboard";

import { ReactComponent as DangerIcon } from "icons/danger.svg";

const InputField = (props) => <Input {...props} />;

const validate = (values) => {
  const errors = {};
  if (!values.amount) {
    errors.amount = "Wymagane";
  }
  if (!values.description) {
    errors.description = "Uzasadnij uwagę";
  }
  return errors;
};

let timeout;

const UserAdjustmentModal = ({
  handleSubmit,
  handleClose,
  user_id,
  full_name,
  pristine,
  refetch,
  date,
}) => {
  const [active, setActive] = useState(false);
  const [is_saving, setSaving] = useState(false);

  useEffect(() => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  const onSubmit = async ({ amount, description }) => {
    try {
      setSaving(true);
      await createUserAdjustment({ amount, description, user_id, date });
      refetch()
      handleClose();
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="popup-wrapper">
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className={`popup ${active ? "active" : ""}`}
      >
        <header className="popup__header">
          <DangerIcon />
          <h2 className="dashboard__title heading">Zgłoś uwagę</h2>
          <Button type="close" onClick={handleClose} />
        </header>
        <div className="popup__body">
          <div className="popup-text">
            <p>
              Zgłaszasz uwagę dla <strong>{full_name}.</strong>
            </p>
            <div style={{ marginTop: 20 }}>
              <Field
                type="number"
                id="amount"
                name="amount"
                component={InputField}
                label={
                  <>
                    Wartość{" "}
                    <span className="text-muted">
                      (jeśli to nagana wartość powinna być ujemna)
                    </span>
                  </>
                }
              />
              <Field
                id="description"
                name="description"
                component={Textarea}
                label="Opis"
              />
            </div>
          </div>
        </div>
        <div
          className="popup__footer"
          style={{
            padding: "10px 15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <button
            disabled={pristine || is_saving}
            type="submit"
            onClick={handleSubmit(onSubmit)}
            className="btn btn-sm btn-green"
          >
            <span>{is_saving ? "Proszę czekać..." : "Zgłoś"}</span>
          </button>
        </div>
      </form>
    </div>,
    document.getElementById("root")
  );
};

export default reduxForm({
  form: "user_adjustment",
  validate,
  enableReinitialize: true,
})(UserAdjustmentModal);
